const localStorageKey = 'authToken';

export default async function client(uri, { body, ...customConfig } = {}) {
  const token = window.sessionStorage.getItem(localStorageKey);
  const headers = { authorization: token, 'Content-Type': 'application/json' };

  const config = {
    method: body ? 'POST' : 'GET',
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  return window.fetch(uri, config).then(async (response) => {
    if (response.status === 401) {
      // TODO: Handle reAuth after moving its logic to a helper func.
      // reAuth();
      return Promise.reject(new Error('Unauthorized'));
    }

    if (response.ok) {
      // hack: fetch can't convert empty response body using response.json()
      const textBodyResponse = await response.text();
      return textBodyResponse ? JSON.parse(textBodyResponse) : response;
    }

    const errorMessage = await response.text();
    return Promise.reject(new Error(errorMessage));
  });
}
